import styles from './index.module.less';
import Image from 'next/image';
import dayjs from 'dayjs';
import { imgUrl } from '@/shared/utils';
import { useMemo, useState } from 'react';
import Link from 'next/link';
type IBlogList = {
  date: string;
  isTop: boolean;
  articleId: number;
  title_id: string;
  cover_image: string;
  title: string;
};
interface IProps {
  blogList: IBlogList[];
  topBlogList: IBlogList[];
  blogTitle: string;
  topBlogTitle: string;
  textAlign?: 'center' | 'left';
}
const Index = ({ blogList, topBlogList, blogTitle, topBlogTitle, textAlign = 'center' }: IProps) => {
  const [isShowMore, setIsShowMore] = useState(false);
  const memoizedBlogList = useMemo(() => {
    if (isShowMore) {
      return blogList;
    }
    return blogList?.slice(0, 8);
  }, [blogList, isShowMore]);
  const memoizedTopBlogList = useMemo(() => {
    if (isShowMore) {
      return topBlogList;
    }
    return topBlogList?.slice(0, 8);
  }, [topBlogList, isShowMore]);
  return (
    <div className={styles.container}>
      {topBlogTitle && (
        <div className={styles.top}>
          <h2 className={styles.topTitle} style={{ textAlign }}>
            {topBlogTitle}
          </h2>
          <ul className={styles.topBlogList}>
            {memoizedTopBlogList?.length > 0 &&
              memoizedTopBlogList?.map((item: IBlogList) => (
                <li key={item.articleId} className={styles.topBlogItem}>
                  <Link href={`/blog/${item.title_id}`} title={item.title} prefetch={false} className={styles.blogLink}>
                    <Image
                      src={imgUrl(item.cover_image, 'mid')}
                      alt={item.title_id}
                      width={1200}
                      height={1200}
                      className={styles.blogImage}
                    />
                    <div className={styles.blogContent}>
                      <h3 className={styles.blogTitle}>{item.title}</h3>
                      <p className={styles.blogDate}>{dayjs(item.date).format('MMMM D, YYYY')}</p>
                    </div>
                  </Link>
                </li>
              ))}
          </ul>
          {topBlogList?.length > 8 && !isShowMore && (
            <div onClick={() => setIsShowMore(true)} className={styles.loadMore}>
              + Load More
            </div>
          )}
        </div>
      )}
      {blogTitle && (
        <div className={styles.bottom}>
          <h2 className={styles.bottomTitle} style={{ textAlign }}>
            {blogTitle}
          </h2>
          <ul className={styles.bottomBlogList}>
            {memoizedBlogList?.length > 0 &&
              memoizedBlogList?.map((item: IBlogList) => (
                <li key={item.articleId} className={styles.bottomBlogItem}>
                  <Link href={`/blog/${item.title_id}`} title={item.title} prefetch={false} className={styles.blogLink}>
                    <Image
                      src={imgUrl(item.cover_image, 'mid')}
                      alt={item.title_id}
                      width={500}
                      height={282}
                      className={styles.blogImage}
                    />
                    <div className={styles.blogContent}>
                      <h3 className={styles.blogTitle}>{item.title}</h3>
                      <p className={styles.blogDate}>{dayjs(item.date).format('MMMM D, YYYY')}</p>
                    </div>
                  </Link>
                </li>
              ))}
          </ul>
          {blogList?.length > 8 && !isShowMore && (
            <div onClick={() => setIsShowMore(true)} className={styles.loadMore}>
              + Load More
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default Index;
